import type { PromotionModuleOptions } from '@promotion/types'

export default defineNuxtPlugin((app) => {
    if (!app.$config.public?.signupBundleExperiments) return
    if (!app.$config.public.signupBundleExperiments?.a) return
    if (!app.$config.public.signupBundleExperiments?.b) return

    const promotionConfig = app.$config.public.promotion as PromotionModuleOptions

    (app.$config.public.promotion as PromotionModuleOptions) = {
        ...promotionConfig,
        signupBundleExperiments: {
            a: app.$config.public.signupBundleExperiments.a.toString(),
            b: app.$config.public.signupBundleExperiments.b.toString(),
        }
    }
})
